// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__340IY","title":"Header_title__1sKet","left":"Header_left__36PPw","clinicName":"Header_clinicName__1MZVL"};